import React, {Component} from 'react'


import {Row, Col } from "react-bootstrap";
import OgaTable from "../OgaTables/OgaTable";
import Loader from "../elements/loader/Loader";
import HttpClient from "../../utils/HttpClient/HttpClient";
import TopWidgetComponent from "./TopWidgetComponent";

export default class Widget1 extends Component {


    httpClient;
    constructor(props){
        super(props);
        this.state = {
            methods: null,
            checked: false,
            loading: false,
            loaded: false,
            values: null
        };
        this.httpClient = new HttpClient(true);
    }

    componentWillMount(){
        this.httpClient.get("oga/widgets/rank-detail")
            .then((res) => {
                console.log("oga/widgets/rank-detail success", res.data);
                this.setState({ loaded: true, values: res.data})
            })
            .catch((err) => {
            console.error("oga/widgets/rank-detail Error", err);
        });
    }

    render() {
        let loaded = this.state.loaded;
        return (
            <div className="widget-container w-100">
                {
                    !loaded ?
                        <div className={"w-100 centered"} style={{ minHeight: "400px"}}>
                            <Loader show={true}/>
                        </div> :
                        <div>
                            <Row className="widget-container-padding">
                                <Col md={12} className={"no-padding no-margin"}>
                                    <form>

                                        <TopWidgetComponent id={this.props.id}
                                                            label={this.props.name}
                                                            onSelectionChange={ (val, id) => this.props.onSelectionChange(val, id) }
                                                            isDashboard={this.props.isDashboard}/>

                                    </form>
                                </Col>
                                <Col md={12} className={"no-padding no-margin"}>
                                    <div className="flex bottom-margin-8">
                                        <div className={"container-centered"}>
                                            <div className="square-20 m-right-8 paymentRank"/>
                                            <small className="m-right-8">Rango de pago</small>
                                            <div className="square-20 m-right-8 currentRank"/>
                                            <small className="m-right-8">Rango actual</small>
                                            <div className="square-20 m-right-8 paymentRank currentRank"/>
                                            <small className="m-right-8">Rango actual / Rango de pago</small>
                                        </div>
                                    </div>
                                   <OgaTable
                                       loading={this.state.loading}
                                       headers={[ "Rango", "Afiliados de red", "Afiliados directos" ]}
                                       properties={[ "rank", "networkAffiliates", "directAffiliates" ] }
                                       pullRight={ [ 0, 1, 2 ]}
                                       extClass={ (v) => {
                                           let rank = "";
                                           if (v.paymentRank){
                                               rank += "paymentRank ";
                                           }

                                           if (v.currentRank){
                                               rank += "currentRank ";
                                           }

                                           return rank;
                                       }

                                       }
                                       values={this.state.values}/>
                                </Col>
                            </Row>
                        </div>
                }

            </div>
        )
    }

}



// WEBPACK FOOTER //
// ./src/components/Widgets/Widget1.jsx